import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import CardContent from '@material-ui/core/CardContent'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import CheckIcon from '@material-ui/icons/Check'
import AddIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Remove'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'

import Divider from '@material-ui/core/Divider'
import Button from '@material-ui/core/Button'

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import PricingDialog from './PricingDialog'

import * as API from '../../utils/api'
import { receiveOffices } from '../../actions/offices'

import t from '../../utils/lang/office'

const styles = theme => ({
  root: {
    flexDirection: 'column'
  },
  heading: {
    marginTop: '13px',
    marginBottom: '20px',
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 500,
  },
  formControl: {
    margin: '0 0 10px',
    width: '300px',
    display: 'block'
  },
  dataRow: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap'
  },
  dataLabel: {
    width: '250px',
    lineHeight: '2rem'
  },
  dataValue: {
    width: '300px',
    lineHeight: '2rem',
    fontWeight: '500'
  },
  outOfDate: {
    fontWeight: '400',
    textDecoration: 'line-through'
  },
  updated: {
    color: 'rgb(244, 67, 54)'
  },
  deleted: {
    color: 'rgb(244, 67, 54)',
    textDecoration: 'line-through'
  },
  list: {
    width: '100%',
    maxWidth: '300px',
  },
  listItem: {
    paddingLeft: '0'
  },
  listChangedItem: {
    color: 'rgb(198, 40, 40)'
  }
});

class PricingTab extends Component {
  state = {
    openPricingDialog: false,
  }

  handlePricingDialogOpen = (event) => {
    this.setState({ openPricingDialog: true });
  }

  handlePricingDialogClose = () => {
    this.setState({ openPricingDialog: false });
  }

  handleRefreshPackets = () => {
    const { officeId, dispatch, userId } = this.props
    const authedUserId = localStorage.getItem('authedUserId')

    API.logOfficeUpdate(officeId, userId)

    API.getOffices(authedUserId)
      .then((offices) => {
        dispatch(receiveOffices(offices))
      })
  }

  render() {
    const { openPricingDialog } = this.state
    const { classes, officeId, data } = this.props
    const lang = 'en'
    const update = data.update

    const packets = Object.values(data)
    const guidePricesIndexes = [0,1,2,3,4]
    const additionalCostsIndexes = [5,6,7,8,9,10,11]

    return (
      <Fragment>
        <CardContent>
          <ExpansionPanel defaultExpanded>
            <ExpansionPanelDetails className={classes.root}>
              <div className={classes.dataRow}>
                <Typography className={classes.heading}>{t[lang].guidePricesHeader}</Typography>
              </div>

              {guidePricesIndexes.map((id) => (
                <div key={id} className={classes.dataRow}>
                  <Typography className={classes.dataLabel}>{packets[id].name}</Typography>
                  <Typography className={classes.dataValue}>
                    {typeof update === 'object' && update.hasOwnProperty(packets[id].name) && packets[id].value !== update.value
                      ? (<Fragment>
                          <span className={classes.outOfDate}>{packets[id].value}</span>
                          <span className={classes.updated}> {update.value}</span>
                        </Fragment>)
                      : packets[id].value}
                  </Typography>
                </div>
              ))}

              <div className={classes.dataRow}>
                <Typography className={classes.heading}>{t[lang].additionalCostsHeader}</Typography>
              </div>

              {additionalCostsIndexes.map((id) => (
                <div key={id} className={classes.dataRow}>
                  <Typography className={classes.dataLabel}>{packets[id].name}</Typography>
                  <Typography className={classes.dataValue}>
                    {typeof update === 'object' && update.hasOwnProperty(packets[id].name) && packets[id].value !== update.value
                      ? (<Fragment>
                          <span className={classes.outOfDate}>{packets[id].value}</span>
                          <span className={classes.updated}> {update.value}</span>
                        </Fragment>)
                      : packets[id].value}
                  </Typography>
                </div>
              ))}
            </ExpansionPanelDetails>
            <Divider />
            <ExpansionPanelActions>
              <Button size="small" color="primary" onClick={event => this.handlePricingDialogOpen(event)}>
                Edit
              </Button>
            </ExpansionPanelActions>
          </ExpansionPanel>
        </CardContent>

        <PricingDialog data={packets} officeId={officeId} open={openPricingDialog} handleClose={this.handlePricingDialogClose} handleRefreshPackets={this.handleRefreshPackets} />
      </Fragment>
    )
  }
}

PricingTab.propTypes = {
  classes: PropTypes.object.isRequired,
  officeId: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired
}

function mapStateToProps ({ authedUser }, props) {
  return {
    userId: authedUser.id
  }
}

export default connect(mapStateToProps)(withStyles(styles)(PricingTab))


// WEBPACK FOOTER //
// ./src/components/Offices/PricingTab.js